import SearchAppBar from "./components/SearchBar";
import HeroSection from "./components/heroContainer";
import StatsContainer from "./components/statsContainer";
import "./css/index.css";
import TopRepos from "./components/topRepos";
import Testdata from "./components/dataFetch";
import { useLocation } from "react-router-dom";

function userNotExists() {
  return (
    <header
      className="heroSection section--lg"
      style={{ height: "100vh", textAlign: "center" }}
    >
      <h2 style={{ paddingInline: "1rem" }}>
        Enter a <span style={{ color: "var(--component-color)" }}>Github</span>{" "}
        Username to Analyze :)
      </h2>
    </header>
  );
}

function userExists() {
  return (
    <section>
      <Testdata />
      <HeroSection />
      <StatsContainer />
      <TopRepos />
    </section>
  );
}

function HeroContainer() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const user = searchParams.get("user");
  return user ? userExists() : userNotExists();
}

function App() {
  return (
    <div className="App">
      <SearchAppBar />
      <HeroContainer />
    </div>
  );
}

export default App;
